<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :height="this.height"
    :width="this.width"
    class='dr-container'>
    <rect
      v-for="(d, i) in disabilityRates"
      :key="'dr-bar-'+i+'-'+reportOfSickness.id"
      :class="d === 0 ? 'dr-bar recovered' : 'dr-bar'"
      :x="getXBar(i)"
      :y="getY(i)"
      rx='2'
      ry='2'
      :width="periodWidth - 2"
      :height="getHeight(d)" />

    <g v-for="(d, i) in disabilityRates" :key="'dr-line-'+i+'-'+reportOfSickness.id">
      <line
        :x1="getXLine(i)"
        :x2="getXLine(i + 1)"
        :y1="getY(i)"
        :y2="getY(i + 1)"
        v-if="isLineVisible(i)"
        :class="getLineClass(i + 1)" />
    </g>

    <circle
      v-for="(d, i) in disabilityRates"
      :key="'dr-circle-'+i+'-'+reportOfSickness.id"
      :class="getCircleClass(i)"
      :cx="getXLine(i)"
      :cy="getY(i)" r='3.5' />
  </svg>
</template>

<script>
export default {
  name: 'ReportOfSicknessDisabilityRateGraph',
  props: {
    reportOfSickness: Object,
    width: Number,
    height: Number
  },

  methods: {
    getXBar (i) {
      return i * this.periodWidth + 1;
    },
    getXLine (i) {
      return i * this.periodWidth + (this.periodWidth / 2);
    },

    getY (index) {
      let dr = 0.00;

      if (index < this.disabilityRates.length) {
        dr = this.disabilityRates[index];
      } else if (index === this.disabilityRates.length) {
        dr = this.disabilityRates[this.disabilityRates.length - 1];
      }

      if (dr < 1) { dr = 5; }
      return (100 - dr).toString() + '%';
    },

    getHeight (d) {
      if (d < 1) d = 5;
      return d.toString() + '%';
    },

    isLineVisible (index) {
      return (index < this.disabilityRates.length - 1);
    },

    getCircleClass (index) {
      if (index === 0) { return 'dr-circle'; }
      if (index === this.disabilityRates.length - 1 && this.disabilityRates[index] === 0.00) { return 'dr-circle-recovered'; }
      return 'dr-circle-period';
    },

    getLineClass (index) {
      if (this.disabilityRates[index] === 0.00) { return 'dr-line-recovered'; }
      return 'dr-line';
    }
  },

  computed: {
    disabilityRates () {
      let result = [];

      result.push(parseFloat(this.reportOfSickness.disabilityRate));

      this.reportOfSickness.periods.forEach(p => {
        result.push(parseFloat(p.disabilityRate));
      });

      if (this.reportOfSickness.recovery) {
        result.push(0.00);
      }

      return result;
    },

    periodWidth () {
      return (this.width / (this.disabilityRates.length));
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';
.dr-container {
  display: block;
  overflow: visible;
}

.dr-bar {
  fill: $secondary-lighten-4;

  &.recovered {
    fill: $positive-lighten-2;
  }
}

.dr-line {
  stroke: $secondary;
  stroke-width: 2.5;
}

.dr-line-recovered {
  stroke: url(#recoveryGradient);
  stroke-width: 2.5;
}

.dr-circle {
  stroke: $secondary;
  stroke-width: 2.5;
  fill: white;
}

.dr-circle-recovered {
  stroke: $positive;
  stroke-width: 2.5;
  fill: white;
}

.dr-circle-period {
  stroke: white;
  stroke-width: 2.5;
  fill: $secondary;
}

</style>
